export default "__VITE_ASSET__CT5w4_Zo__"